import React, { useEffect, useState } from "react";
import styles from "./staffmanage.module.css";
import ContractSettings from "./contractsettings";
import StaffRoster from "./staffroster";
import StaffOnboarding from "./staffonboarding";
import StaffOffboarding from "./staffoffboarding";
import { readStaffManageState, StaffPill } from "./navigation";

//직원관리 — 사이드바 독립 메뉴 (/dashboard/staffmanage, menulist requireTodoistKey 로 노출 제어)
//알약 탭 4개: 직원명부 / 신규직원 TODO / 퇴사직원 TODO / 계약서 변수 관리
//전체학생정보에서 넘어온 경우 쿼리스트링(navigation.ts)으로 알약·검색어를 시드. 이미 이 페이지에 있을 때 또 넘어와도 반영되게 location.search 를 감시
const StaffManageMain: React.FC<any> = (props) => {

    const initial = readStaffManageState(props.location);
    const [pill, setPill] = useState<StaffPill>(initial && initial.pill ? initial.pill : "roster");
    const [search, setSearch] = useState<string>(initial ? initial.search : "");
    const [seed, setSeed] = useState(0);   //검색어 재시드용 리마운트 키

    useEffect(() => {
        if (props.activateMenuList) {
            props.activateMenuList("staffmanage");
        }
    }, []);

    useEffect(() => {
        const next = readStaffManageState(props.location);
        if (next) {
            setPill(next.pill);
            setSearch(next.search);
            setSeed((s) => s + 1);
        }
    }, [props.location ? props.location.search : ""]);

    if (!props.user || !props.user.todoistApiKey) {
        return (
            <div className={styles.main}>
                <div style={{ marginTop: "50px", fontFamily: "Apple_R", color: "#6b7280" }}>
                    권한이 없습니다 (todoistApiKey 필요)
                </div>
            </div>
        );
    }

    return (
        <div className={styles.main}>
            <div className={styles.pageTitle}>직원관리</div>

            <div className={styles.searchMenu}>
                <div onClick={() => setPill("roster")} className={`${styles.searchMenuDiv} ${pill === "roster" ? styles.active : ""}`}>
                    직원명부
                </div>
                <div onClick={() => setPill("newTodo")} className={`${styles.searchMenuDiv} ${pill === "newTodo" ? styles.active : ""}`}>
                    신규직원 TODO
                </div>
                <div onClick={() => setPill("leaveTodo")} className={`${styles.searchMenuDiv} ${pill === "leaveTodo" ? styles.active : ""}`}>
                    퇴사직원 TODO
                </div>
                <div onClick={() => setPill("variables")} className={`${styles.searchMenuDiv} ${pill === "variables" ? styles.active : ""}`}>
                    계약서 변수 관리
                </div>
            </div>

            <div style={{ width: "96%", paddingBottom: "80px" }}>
                {pill === "roster" && <StaffRoster key={`roster-${seed}`} user={props.user} initialSearch={search} />}
                {pill === "newTodo" && <StaffOnboarding key={`on-${seed}`} user={props.user} initialSearch={search} />}
                {pill === "leaveTodo" && <StaffOffboarding key={`off-${seed}`} user={props.user} initialSearch={search} />}
                {pill === "variables" && <ContractSettings user={props.user} />}
            </div>
        </div>
    );
};

export default StaffManageMain;
